import { render, staticRenderFns } from "./CartTotals.vue?vue&type=template&id=490626a9&scoped=true"
import script from "./CartTotals.vue?vue&type=script&lang=js"
export * from "./CartTotals.vue?vue&type=script&lang=js"
import style0 from "./CartTotals.vue?vue&type=style&index=0&id=490626a9&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "490626a9",
  null
  
)

export default component.exports